const CHURN_ZERO_KEY = process.env.REACT_APP_CHURN_ZERO_KEY;

// Track the last initialized contact to prevent duplicate calls
let lastInitializedContact = null;

export function addChurnZero() {
  if (document.getElementById("churnzero-script")) {
    return;
  }

  // Initialize ChurnZero array
  window.ChurnZero = window.ChurnZero || [];

  // Add ChurnZero script
  const script = document.createElement("script");
  script.id = "churnzero-script";
  script.type = "text/javascript";
  script.async = true;
  script.src = "https://fullsteam.us1app.churnzero.net/churnzero.js";

  const firstScript = document.getElementsByTagName("script")[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

export function initializeChurnZeroContact(
  accountExternalId,
  contactExternalId
) {
  if (!window.ChurnZero) {
    console.warn("ChurnZero is not loaded yet");
    return;
  }

  if (!accountExternalId || !contactExternalId) {
    console.warn("ChurnZero: Missing account or contact ID");
    return;
  }

  // Only initialize if the contact info has changed
  const contactKey = `${accountExternalId}:${contactExternalId}`;
  if (lastInitializedContact === contactKey) {
    return;
  }
  window.ChurnZero.push(["setAppKey", CHURN_ZERO_KEY]);
  window.ChurnZero.push(["setContact", accountExternalId, contactExternalId]);

  lastInitializedContact = contactKey;
}
